export const buttonCss = {
  "&&": {
    fontSize: "14px",
  },
};
